module.exports = __webpack_public_path__ + "img/Sveta.2504c3ad.png";